import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {SignInComponent} from './sign-in/sign-in.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ForgotPasswordSubmitComponent} from './forgot-password/forgot-password-submit.component';
import {ResetPasswordComponent} from './forgot-password/reset-password.component';
import {ChangePasswordComponent} from '../shared/change-password/change-password.component';
import {ChangePasswordSubmitComponent} from '../shared/change-password/change-password-submit.component';
import {AuthGuard} from './auth.guard';
import { AuthModule } from './auth.module';
// AngularTokenService
const routes: Routes = [
  {path: 'sign-in', component: SignInComponent,
    data: { title: 'BankExec® Sign In' }},
  { path: 'forgot-password', component: ForgotPasswordComponent,
    data: { title: 'BankExec® Forgot Password' }},
  { path: 'forgot-password-submit', component: ForgotPasswordSubmitComponent,
    data: { title: 'BankExec® Forgot Password Submit' }},
  { path: 'reset-password', component: ResetPasswordComponent,
    data: { title: 'BankExec® Reset Password' }},
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthGuard], data: { title: 'BankExec® Change Password' }},
  { path: 'change-password-submit', component: ChangePasswordSubmitComponent, canActivate: [AuthGuard],
    data: { title: 'BankExec® Change Password Submit' }},
  { path: 'change-password-submit', component: ChangePasswordSubmitComponent, canActivate: [AuthGuard], data: { title: 'BankExec® Change Password Submit' }}
];
export const auth_routing: ModuleWithProviders<AuthModule> = RouterModule.forChild(routes);
